import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const BoosterWidget = ({
  width = 256,
  height = 144,
  color,
  className,
  ...rest
}: {
  width: number;
  height: number;
  color?: string;
  className?: string;
}) => {
  const { token } = useToken() as unknown as CustomThemeToken;
  const currentColor = color ?? token.colorBgContainer;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 256 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path d="M5 93H3C1.89543 93 1 92.1046 1 91L1 83C1 81.8954 1.89543 81 3 81H5L5 93Z" fill={token.colorBorder} />
      <g filter="url(#filter0_ddd_25646_12080)">
        <path
          d="M5 12C5 7.58172 8.58172 4 13 4H243C247.418 4 251 7.58172 251 12V130C251 134.418 247.418 138 243 138H13C8.58173 138 5 134.418 5 130V12Z"
          fill={currentColor}
          shapeRendering="crispEdges"
        />
        <path
          d="M13 4.5H243C247.142 4.5 250.5 7.85787 250.5 12V130C250.5 134.142 247.142 137.5 243 137.5H13C8.85787 137.5 5.5 134.142 5.5 130V12C5.5 7.85787 8.85787 4.5 13 4.5Z"
          stroke={currentColor}
          shapeRendering="crispEdges"
        />
        <mask id="path-4-inside-1_25646_12080" fill={currentColor}>
          <path d="M5 12C5 7.58172 8.58172 4 13 4H195V138H5V12Z" />
        </mask>
        <path
          d="M5 4H195H5ZM195 138H5H195ZM5 138V4V138ZM196 4V138H194V4H196Z"
          fill={token.colorBorderSecondary}
          mask="url(#path-4-inside-1_25646_12080)"
        />
      </g>
      <path
        d="M251 81H253C254.105 81 255 81.8954 255 83V91C255 92.1046 254.105 93 253 93H251V81Z"
        fill={token.colorBorder}
      />
      <defs>
        <filter
          id="filter0_ddd_25646_12080"
          x="0"
          y="0"
          width="256"
          height="144"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_25646_12080" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect2_dropShadow_25646_12080" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_25646_12080" result="effect2_dropShadow_25646_12080" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_25646_12080" result="effect3_dropShadow_25646_12080" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_25646_12080" result="shape" />
        </filter>
        <clipPath id="clip0_25646_12080">
          <rect width="19.8621" height="19.8621" fill={currentColor} transform="translate(213 23)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BoosterWidget;
